/*
 Copyright 2026 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Blueprint API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SystemPermission = {
    CreateMsels: 'CreateMsels',
    ViewMsels: 'ViewMsels',
    EditMsels: 'EditMsels',
    ManageMsels: 'ManageMsels',
    ViewUnits: 'ViewUnits',
    ManageUnits: 'ManageUnits',
    ViewOrganizations: 'ViewOrganizations',
    ManageOrganizations: 'ManageOrganizations',
    ViewDataFields: 'ViewDataFields',
    ManageDataFields: 'ManageDataFields',
    ViewInjectTypes: 'ViewInjectTypes',
    ManageInjectTypes: 'ManageInjectTypes',
    ViewCatalogs: 'ViewCatalogs',
    ManageCatalogs: 'ManageCatalogs',
    ViewGalleryCards: 'ViewGalleryCards',
    ManageGalleryCards: 'ManageGalleryCards',
    ViewCiteActions: 'ViewCiteActions',
    ManageCiteActions: 'ManageCiteActions',
    ViewCiteDuties: 'ViewCiteDuties',
    ManageCiteDuties: 'ManageCiteDuties',
    ViewUsers: 'ViewUsers',
    ManageUsers: 'ManageUsers',
    ViewRoles: 'ViewRoles',
    ManageRoles: 'ManageRoles',
    ViewGroups: 'ViewGroups',
    ManageGroups: 'ManageGroups'
} as const;
export type SystemPermission = typeof SystemPermission[keyof typeof SystemPermission];

